<template>
  <div
    class="safe-area-inset-bottom"
    :style="'background-color:' + backgroundColor"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "SafeAreaInsetBottom",
  props: {
    backgroundColor: {
      type: String,
      default: "#FFF"
    }
  }
};
</script>

<style lang="scss" scoped>
.safe-area-inset-bottom {
  width: 100%;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
</style>
